import {FC, useMemo} from 'react';
import {Col, Row} from 'react-bootstrap';
import {Formik, Form} from 'formik';
import * as Yup from 'yup';
import {FormPageFooter} from "@components/falcon/common/forms";
import {GoalBaseInfoBlock} from "./forms";
import {ConditionType, GoalFormValues} from "./forms/goalBaseInfoBlock";

interface GoalFormProps {
    initialValues: GoalFormValues;
    onSubmit: (values: GoalFormValues) => Promise<any>;
    onDelete?: () => any;
    editForm?: boolean;
    cancelUrl: string;
}

const GoalForm: FC<GoalFormProps> = ({
    initialValues,
    onSubmit,
    onDelete,
    editForm,
    cancelUrl
}) => {

    const validationSchema = useMemo(() => Yup.object<GoalFormValues>({
        name: Yup.string()
            .max(256)
            .required(),
        description: Yup.string()
            .max(10000),
        isActive: Yup.boolean()
            .required(),
        hidden: Yup.boolean()
            .required(),
        order: Yup.number()
            .required(),
        conditionType: Yup.mixed<ConditionType>()
            .oneOf(Object.values(ConditionType))
            .required()
    }), []);

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            enableReinitialize
        >
            <Form>
                <Row className="g-3">
                    <Col xs={12}>
                        <GoalBaseInfoBlock editForm={editForm} />
                    </Col>
                    <Col>
                        <FormPageFooter
                            cancelUrl={cancelUrl}
                            onDelete={onDelete} />
                    </Col>
                </Row>
            </Form>
        </Formik>
    );
};

export default GoalForm;
